import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=223956b0&scoped=true"
import script from "./Indicators.vue?vue&type=script&lang=js"
export * from "./Indicators.vue?vue&type=script&lang=js"
import style0 from "./Indicators.vue?vue&type=style&index=0&id=223956b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223956b0",
  null
  
)

export default component.exports